import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { DiarySection } from './components/DiarySection';
import { ProductInfo } from './components/ProductInfo';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
    const gclid = new URLSearchParams(window.location.search).get('gclid');
    if (gclid) {
      document.querySelectorAll('a[href*="hunderunde.shop"]').forEach(link => {
        const el = link as HTMLAnchorElement;
        const sep = el.href.includes('?') ? '&' : '?';
        el.href = el.href + sep + 'gclid=' + gclid;
      });
    }
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-sage selection:text-forest overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <div className="relative" data-id="element-4">
          {/* Subtle background decoration for the diary section */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-5">
            <div className="absolute top-20 -left-32 w-96 h-96 bg-sage/30 rounded-full blur-3xl" data-id="element-6"></div>
            <div className="absolute bottom-40 -right-32 w-96 h-96 bg-brown/5 rounded-full blur-3xl" data-id="element-7"></div>
          </div>

          <div className="relative z-10" data-id="element-8">
            <DiarySection data-id="element-9" />
          </div>
        </div>

        <ProductInfo data-id="element-10" />
        <Testimonials data-id="element-11" />
        <CTASection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}